import { render, staticRenderFns } from "./MemberLayout.vue?vue&type=template&id=04d8b738"
import script from "./MemberLayout.vue?vue&type=script&lang=js"
export * from "./MemberLayout.vue?vue&type=script&lang=js"
import style0 from "./MemberLayout.vue?vue&type=style&index=0&id=04d8b738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports